module.exports = __webpack_public_path__ + "img/login_icon.aa7b0e49.png";